export default __webpack_public_path__ + "static/media/ico_trash_all.8356606c.svg";